var _path, _path2, _path3, _path4, _path5, _path6, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64648 5.63672C10.1988 5.63672 10.6465 6.08443 10.6465 6.63672V10.6367C10.6465 11.189 10.1988 11.6367 9.64648 11.6367C9.0942 11.6367 8.64648 11.189 8.64648 10.6367L8.64648 6.63672C8.64648 6.08443 9.0942 5.63672 9.64648 5.63672Z",
    fill: "url(#paint0_linear_2625_21347)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.64648 5.63672C10.1988 5.63672 10.6465 6.08443 10.6465 6.63672V10.6367C10.6465 11.189 10.1988 11.6367 9.64648 11.6367C9.0942 11.6367 8.64648 11.189 8.64648 10.6367L8.64648 6.63672C8.64648 6.08443 9.0942 5.63672 9.64648 5.63672Z",
    fill: "#6F00DE",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93938 9.92961C9.3299 9.53909 9.96307 9.53909 10.3536 9.92961L12.3536 11.9296C12.7441 12.3201 12.7441 12.9533 12.3536 13.3438C11.9631 13.7343 11.3299 13.7343 10.9394 13.3438L8.93938 11.3438C8.54885 10.9533 8.54885 10.3201 8.93938 9.92961Z",
    fill: "url(#paint1_linear_2625_21347)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.93938 9.92961C9.3299 9.53909 9.96307 9.53909 10.3536 9.92961L12.3536 11.9296C12.7441 12.3201 12.7441 12.9533 12.3536 13.3438C11.9631 13.7343 11.3299 13.7343 10.9394 13.3438L8.93938 11.3438C8.54885 10.9533 8.54885 10.3201 8.93938 9.92961Z",
    fill: "#6F00DE",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.353516 5.63672C-0.353516 2.8753 1.88506 0.636719 4.64648 0.636719H14.6465C17.4079 0.636719 19.6465 2.8753 19.6465 5.63672V15.6367C19.6465 18.3981 17.4079 20.6367 14.6465 20.6367H4.64648C1.88506 20.6367 -0.353516 18.3981 -0.353516 15.6367V5.63672ZM4.64648 2.63672C2.98963 2.63672 1.64648 3.97986 1.64648 5.63672V15.6367C1.64648 17.2936 2.98963 18.6367 4.64648 18.6367H14.6465C16.3033 18.6367 17.6465 17.2936 17.6465 15.6367V5.63672C17.6465 3.97986 16.3033 2.63672 14.6465 2.63672H4.64648Z",
    fill: "url(#paint2_linear_2625_21347)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.353516 5.63672C-0.353516 2.8753 1.88506 0.636719 4.64648 0.636719H14.6465C17.4079 0.636719 19.6465 2.8753 19.6465 5.63672V15.6367C19.6465 18.3981 17.4079 20.6367 14.6465 20.6367H4.64648C1.88506 20.6367 -0.353516 18.3981 -0.353516 15.6367V5.63672ZM4.64648 2.63672C2.98963 2.63672 1.64648 3.97986 1.64648 5.63672V15.6367C1.64648 17.2936 2.98963 18.6367 4.64648 18.6367H14.6465C16.3033 18.6367 17.6465 17.2936 17.6465 15.6367V5.63672C17.6465 3.97986 16.3033 2.63672 14.6465 2.63672H4.64648Z",
    fill: "#6F00DE",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2625_21347",
    x1: 8.64648,
    y1: 8.70989,
    x2: 10.6465,
    y2: 8.70989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2625_21347",
    x1: 8.64648,
    y1: 11.6855,
    x2: 12.6465,
    y2: 11.6855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2625_21347",
    x1: -0.353516,
    y1: 10.8806,
    x2: 19.6465,
    y2: 10.8806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D273FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FF5D6"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.19038cf0d82571ca5a7788397bd5ddbb.svg";
export { ForwardRef as ReactComponent };